import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchAgreement,
  exportEmptyData,
} from "../../../../Actions/Settings/settingsActions.js";
import {
  autoScrolling,
  capitalizeFirstLetter,
} from "../../../../Utils/services.js";
import Loader from "../../../../Components/Common/Loader.js";
import { PaperworkMenu } from "../components/PaperworkMenu/index.js";
import { PaperworkLayout } from "../components/PaperworkLayout/index.js";
import { PaperworkHeader } from "../components/PaperworkHeader/index.js";
import { PaperworkSearchInput } from "../components/PaperworkSearchInput/index.js";

const PAGE_SIZE = 15;

class MembershipAgreement extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);

    this.state = {
      agreementList: [],
      page: 1,
      sortorder: "asc",
      term: "",
      next_page_url: "",
      showLoadingText: false,
      startFresh: true,
      showLoader: false,
    };

    this.props.exportEmptyData({});

    window.onscroll = () => {
      const scrollTop = parseInt(
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop,
        ),
      );
      if (
        document.documentElement.offsetHeight -
          (window.innerHeight + scrollTop) <=
          5 &&
        this.state.next_page_url != null
      ) {
        this.loadMore();
      }
    };
  }

  getAgreement(formData) {
    this.setState({ showLoader: true });
    this.props.fetchAgreement(formData).finally(() => {
      this.setState({ showLoader: false });
    });
  }

  componentDidMount() {
    let formData = {
      params: {
        page: this.state.page,
        pagesize: PAGE_SIZE,
        sortorder: "asc",
        term: this.state.term,
      },
    };
    autoScrolling(true);
    this.getAgreement(formData);
  }

  handleSearch = (term) => {
    localStorage.setItem("sortOnly", true);

    let formData = {
      params: {
        page: 1,
        pagesize: PAGE_SIZE,
        sortorder: this.state.sortorder,
        term,
      },
    };

    this.setState({
      page: 1,
      pagesize: PAGE_SIZE,
      sortorder: this.state.sortorder,
      startFresh: true,
      next_page_url: "",
      agreementList: [],
      term,
    });

    autoScrolling(true);
    this.getAgreement(formData);
  };

  loadMore = () => {
    if (!autoScrolling()) {
      localStorage.setItem("sortOnly", false);
      this.setState({
        startFresh: true,
        showLoader: true,
        showLoadingText: true,
      });
      let formData = {
        params: {
          page: this.state.page,
          pagesize: PAGE_SIZE,
          sortorder:
            this.state.sortorder && this.state.sortorder === "asc"
              ? "asc"
              : this.state.sortorder == "desc"
              ? "desc"
              : "",
          term: this.state.term,
        },
      };
      autoScrolling(true);
      this.getAgreement(formData);
    }
  };

  componentWillUnmount() {
    this.props.exportEmptyData({});
  }

  componentDidUpdate() {
    if (this.state.showLoader) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }

  agreementEdit = (id) => {
    this.props.history.push(`/settings/membership-agreements/${id}/edit`);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showLoader != undefined && nextProps.showLoader == false) {
      return { showLoader: false };
    }
    if (
      nextProps.agreementList != undefined &&
      nextProps.agreementList.data.next_page_url !== prevState.next_page_url
    ) {
      let returnState = {};
      if (prevState.next_page_url == null) {
        localStorage.setItem("sortOnly", false);
        returnState.next_page_url = null;
        autoScrolling(false);
        return returnState;
      }
      if (prevState.agreementList.length == 0 && prevState.startFresh == true) {
        if (localStorage.getItem("sortOnly") == "false") {
          returnState.agreementList = nextProps.agreementList.data.data;
          if (nextProps.agreementList.data.next_page_url != null) {
            returnState.page = prevState.page + 1;
          } else {
            returnState.next_page_url =
              nextProps.agreementList.data.next_page_url;
          }
          returnState.startFresh = false;
          returnState.showLoader = false;
          returnState.showLoadingText = false;
          localStorage.setItem("showLoader", false);
        } else {
          localStorage.setItem("sortOnly", false);
        }
      } else if (
        prevState.agreementList != nextProps.agreementList.data.data &&
        prevState.agreementList.length != 0
      ) {
        returnState.agreementList = [
          ...prevState.agreementList,
          ...nextProps.agreementList.data.data,
        ];
        returnState.page = prevState.page + 1;
        returnState.next_page_url = nextProps.agreementList.data.next_page_url;
        localStorage.setItem("showLoader", false);
        returnState.showLoader = false;
        returnState.showLoadingText = false;
      }
      autoScrolling(false);
      return returnState;
    }
    return null;
  }

  render() {
    return (
      <PaperworkLayout>
        <PaperworkHeader>
          <div className="d-flex align-center gap-8">
            <PaperworkSearchInput onSearch={this.handleSearch} />
            <Link
              to="/settings/membership-agreements/create"
              className="new-blue-btn pull-right"
            >
              Create Agreement
            </Link>
          </div>
        </PaperworkHeader>
        <PaperworkMenu active="membershipAgreement" />
        <div className="juvly-section full-width">
          <div className="table-responsive">
            <table className="table-updated setting-table no-td-border no-hover">
              <thead className="table-updated-thead">
                <tr>
                  <th className="col-xs-10 table-updated-th sorting">
                    Agreement Title
                  </th>
                  <th className="col-xs-2 table-updated-th sorting text-left">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="ajax_body">
                {this.state.agreementList &&
                  this.state.agreementList.length > 0 &&
                  this.state.agreementList.map((obj, idx) => {
                    return (
                      <tr key={idx} className="table-updated-tr">
                        <td className="col-xs-6  table-updated-td">
                          {obj.name ? capitalizeFirstLetter(obj.name) : ""}
                        </td>
                        <td className="col-xs-3  table-updated-td">
                          <a
                            className="m-r-10 edit_setting easy-link p-l-0"
                            onClick={() => this.agreementEdit(obj.id)}
                          >
                            <i className="fa fa-pencil-alt m-r-5" />
                            Edit
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <div
                className={
                  this.state.agreementList
                    ? "no-record no-display"
                    : "no-record"
                }
              ></div>{" "}
              {this.state.agreementList.length <= 0 &&
                this.state.showLoader === false && (
                  <tbody>
                    <tr>
                      <td colSpan="3" className="table-updated-td">
                        <div className="no-record no-float text-center">
                          No Record Found
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
        <div
          className={
            this.state.showLoadingText
              ? "loading-please-wait no-margin-top"
              : "loading-please-wait no-margin-top no-display "
          }
        >
          Loading. Please wait...
        </div>
        <Loader showLoader={this.state.showLoader} isFullWidth={true} />
      </PaperworkLayout>
    );
  }
}

function mapStateToProps(state) {
  const returnState = {};

  if (state.SettingReducer.action === "AGREEMENT_LIST") {
    if (state.SettingReducer.data.status != 200) {
      returnState.showLoader = false;
    } else {
      returnState.agreementList = state.SettingReducer.data;
    }
  }

  if (state.SettingReducer.action === "CLINIC_SEARCH") {
    if (state.SettingReducer.data.status != 200) {
      returnState.showLoader = false;
    } else {
      returnState.clinicSearch = state.SettingReducer.data.data;
    }
  }

  if (state.SettingReducer.action === "SELECTED_CLINIC_LIST") {
    if (state.SettingReducer.data.status != 200) {
      returnState.showLoader = false;
    } else {
      returnState.clinicSearch = state.SettingReducer;
    }
  }

  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAgreement, exportEmptyData }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MembershipAgreement);
